import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App'
import 'babel-polyfill'
if (Number.parseInt === undefined) Number.parseInt = window.parseInt;
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat;

import promise from 'es6-promise';
promise.polyfill();
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from './store/store'
import axios from './util/http'

import vueiInfinite from 'vue-infinite-scroll'
import VueLazyload from 'vue-lazyload'
import VideoPlayer from 'vue-video-player'

import 'jquery'
import './font/font.css'

import vueSwiper from 'vue-awesome-swiper'
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
Vue.use(vueSwiper);

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

// import kindeditor from 'kindeditor'
// import 'kindeditor/themes/default/default.css'
// Vue.use(kindeditor)
// Vue.directive('loaded-callback', {
// 	inserted: function(el, binding, vnode) {
// 	  binding.value(el, binding, vnode)
// 	}
//   })

Vue.use(VueLazyload, {
	preLoad: 5,
	error: 'dist/error.png',
	loading: '../static/load.gif',
	attempt: 1
})
Vue.use(VueMeta, {
	refreshOnceOnNavigation: true
})

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.prototype.$axios = axios
Vue.use(axios)
Vue.config.productionTip = false
Vue.use(vueiInfinite)
Vue.use(ElementUI);


import VueMatomo from 'vue-matomo'
import { fstat } from 'fs';

Vue.use(VueMatomo, {
	host: '//v.jiankanghao.net', // 这里配置你自己的piwik服务器地址和网站ID
	siteId: 1,//siteId值
	// 根据router自动注册
	router: router,
	// // 是否需要在发送追踪信息之前请求许可
	// // 默认false
	requireConsent: false,
	enableLinkTracking: true,
	// // 是否追踪初始页面
	// // 默认true
	trackInitialView: false,
	// // 最终的追踪js文件名
	// // 默认 'piwik'
	trackerFileName: 'matomo',
	debug: false
});

require('./util/kscreenshots')
// require('../static/vue-quill-editor')

function isMobile() {
	if (navigator.userAgent.match(/Android/i)
		|| navigator.userAgent.match(/webOS/i)
		|| navigator.userAgent.match(/iPhone/i)
		|| navigator.userAgent.match(/iPad/i)
		|| navigator.userAgent.match(/iPod/i)
		|| navigator.userAgent.match(/BlackBerry/i)
		|| navigator.userAgent.match(/Windows Phone/i)
	) {
		return true;
	} else {
		return false;

	}
}

// import {returnCitySN} from './util/getip'

// store.commit('setip', returnCitySN())
// console.log(store.state.ip)


let isphone = isMobile()
router.beforeEach((to, from, next) => {
	// localStorage.clear()
	// 判断是否是移动端环境
	if (!isphone) {
		// console.log('ispc')
		// var ip = returnCitySN()
		// console.log(returnCitySN())
		axios.get('ip')
		.then(function(res){
			// console.log(res)
			store.commit('setwhitelist', res.data.data.is_white)
			store.commit('setisjump', res.data.data.is_expire)
			//判断是否登录，有没有user_id
			if(res.data.data.is_white){
				next()
			}else{
				if (to.matched.some(recode => recode.meta.auth)) {
					// console.log(store.state.user_id)
					if (typeof (store.state.user_id) == "undefined") {
						if (to.path == '/login') { //如果是登录页面路径，就直接next()
							next();
							return
						} else { //不然就跳转到登录；
							// console.log(to.path)
							store.commit('setroued', to.path)
							next('/login')
							return
						}
					} else {
						next()
						return
					}
				} else {
					next()
				}
			}
		})
	} else {
		// console.log('ismobile')
		window.location.href = 'https://m.kanguji.com'
	}

})
router.afterEach((to, from, next) => {
	window.scrollTo(0, 0)
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	store: store,
	template: '<App/>',
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js